import { Map, List, fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';

import * as templateLib from 'libs/templateLib';
import * as normal from 'libs/normalizer';

// action types
const INITIAL_STORE = 'template/INITIAL_STORE';
const CHANGE_PARAM = 'template/CHANGE_PARAM';
const RELOAD_TEMPLATE = 'template/RELOAD_TEMPLATE';
const GET_TEMPLATE = 'template/GET_TEMPLATE';
const GET_TEMPLATE_PHISHING = 'template/GET_TEMPLATE_PHISHING';
const ADD_TEMPLATE = 'template/ADD_TEMPLATE';
const UPDATE_TEMPLATE = 'template/UPDATE_TEMPLATE';
const DELETE_TEMPLATE = 'template/DELETE_TEMPLATE';
const COPY_TEMPLATE = 'template/COPY_TEMPLATE';
const SELECT_TEMPLATE = 'template/SELECT_TEMPLATE';
//phishing
const CHANGE_PHISHING_PARAM = 'template/CHANGE_PHISHING_PARAM';
const GET_PHISHING_TEMPLATE = 'template/GET_PHISHING_TEMPLATE';
const SAVE_PHISHING_TEMPLATE = 'template/SAVE_PHISHING_TEMPLATE';
const DELETE_PHISHING_TEMPLATE = 'template/DELETE_PHISHING_TEMPLATE';
const COPY_PHISHING_TEMPLATE = 'template/COPY_PHISHING_TEMPLATE';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const changeParam = createAction(CHANGE_PARAM);
export const reloadTemplate = createAction(RELOAD_TEMPLATE);
export const getTemplate = createAction(GET_TEMPLATE, templateLib.getTemplate);
export const getTemplatePhishing = createAction(GET_TEMPLATE_PHISHING, templateLib.getPhishingTemplate);
export const addTemplate = createAction(ADD_TEMPLATE, templateLib.addTemplate);
export const updateTemplate = createAction(UPDATE_TEMPLATE, templateLib.updateTemplate);
export const deleteTemplate = createAction(DELETE_TEMPLATE, templateLib.deleteTemplate);
export const copyTemplate = createAction(COPY_TEMPLATE, templateLib.copyTemplate);
export const selectTemplate = createAction(SELECT_TEMPLATE);
// phishing
export const changePhishingParam = createAction(CHANGE_PHISHING_PARAM);
export const getPhishingTemplate = createAction(GET_PHISHING_TEMPLATE, templateLib.getPhishingTemplate);
export const savePhishingTemplate = createAction(SAVE_PHISHING_TEMPLATE, templateLib.savePhishingTemplate);
export const deletePhishingTemplate = createAction(DELETE_PHISHING_TEMPLATE, templateLib.deletePhishingTemplate);
export const copyPhishingTemplate = createAction(COPY_PHISHING_TEMPLATE, templateLib.copyPhishingTemplate);

// initial state
const initialState = fromJS({
  data: {
    result: -1,
    success: [],
    fail: []
  },
  // 훈련 템플릿의 피싱 유도 설정 데이터
  templatePhishing: {
    result: -1,
    success: [],
    fail: []
  },
  // 피싱 페이지 데이터
  phishingData: {
    result: -1,
    success: [],
    fail: []
  },
  startExamTemplates: {
    result: -1,
    success: [],
    fail: []
  },
  indexByNo: {},
  needReload: false,
  param: Map({
    filter: Map({}),
    sort: [{ field: 'serviceTemplateNo', order: 'DESC' }]
  }),
  phishingParam: Map({
    filter: Map({}),
    sort: [{ field: 'regEpoch', order: 'DESC' }]
  }),
  totalPages: 0,
  totalCount: 0,
  phishingTotalPages: 0,
  phishingTotalCount: 0,
  selectedTemplate: {
    examTemplateNoArray: [],
    serviceTemplateNoArray: []
  }
});

// reducer
export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    [CHANGE_PARAM]: (state, action) => {
      const { name, value } = action.payload;
      return state.setIn(['param', name], value);
    },
    [CHANGE_PHISHING_PARAM]: (state, action) => {
      const { name, value } = action.payload;
      return state.setIn(['phishingParam', name], value);
    },
    [RELOAD_TEMPLATE]: (state, action) => {
      return state.set('needReload', true);
    },
    [SELECT_TEMPLATE]: (state, action) => {
      const { name, value } = action.payload;
      return state.setIn(['selectedTemplate', name], value);
    },
    ...pender({
      type: GET_TEMPLATE,
      onSuccess: (state, action) => {
        const { data } = action.payload;
        const { offset, limit, type } = action.payload.config.params;

        if (type === 'startExam') {
          // 훈련 실시에서 템플릿 조회(step4) 시 
          const stateObj = normal.payloadDataSaver(state, 'startExamTemplates', data);
          return stateObj;
        } else {
          // 전체 목록 수
          const totalCount = data.list.length > 0 ? data.list[0].rnum + offset : 0;
          // 전체 페이지 수
          const totalPages = Math.ceil(totalCount / limit);

          const stateObj = normal.payloadDataSaver(state, 'data', data);
          return stateObj
            .set('needReload', false)
            .set('totalPages', totalPages)
            .set('totalCount', totalCount)
            .set('indexByNo', fromJS(normal.examTemplateIndexByNo(data.list)));
        }
      },
      onFailure: (state, action) => {
        console.log('GET_TEMPLATE 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    }),
    ...pender({
      type: ADD_TEMPLATE,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('ADD_TEMPLATE 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    }),
    ...pender({
      type: UPDATE_TEMPLATE,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('UPDATE_TEMPLATE 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    }),
    ...pender({
      type: DELETE_TEMPLATE,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('DELETE_TEMPLATE 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    }),

    ...pender({
      type: GET_TEMPLATE_PHISHING,
      onSuccess: (state, action) => {
        const { data } = action.payload;

        const stateObj = normal.payloadDataSaver(state, 'templatePhishing', data);
        return stateObj;
      },
      onFailure: (state, action) => {
        console.log('GET_TEMPLATE_PHISHING 실패');
      }
    }),

    // phishing
    // 조회
    ...pender({
      type: GET_PHISHING_TEMPLATE,
      onSuccess: (state, action) => {
        const { data } = action.payload;
        const { offset, limit } = action.payload.config.params;

        // 전체 목록 수
        const totalCount = data.list.length > 0 ? data.list[0].rnum + offset : 0;
        // 전체 페이지 수
        const totalPages = Math.ceil(totalCount / limit);

        const stateObj = normal.payloadDataSaver(state, 'phishingData', data);
        return stateObj
          .set('needReload', false)
          .set('phishingTotalPages', totalPages)
          .set('phishingTotalCount', totalCount)
          .set('indexByNo', fromJS(normal.examTemplateIndexByNo(data.list)));
      },
      onFailure: (state, action) => {
        console.log('GET_PHISHING_TEMPLATE 실패');
      }
    }),
    // 등록 & 수정
    ...pender({
      type: SAVE_PHISHING_TEMPLATE,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('SAVE_PHISHING_TEMPLATE 실패');
      }
    }),
    // 삭제
    ...pender({
      type: DELETE_PHISHING_TEMPLATE,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('DELETE_PHISHING_TEMPLATE 실패');
      }
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/template.js